import React from 'react';

// Local Components
import Separator from '../FormFields/Separator';
import Searchbar from '../FormFields/Searchbar';
import SortBySearchChip from '../Chips/SortBySearchChip';
import VenueCard from '../Cards/VenueCard';

// Buttons
import { FilterBtn } from '../Buttons/Buttons';

// Typography
import { H4, H3 } from '../../themes/typography';

// FontAwesome Icons
import { FilterIcon, SortByIcon } from '../../icons/FontAwesomeIcon';

// CSS Styles
import '../../styles/components/FoodAndDrinks.css';

export default function SportsAndFitness() {
    return (
        <React.Fragment>
            <div className="sports-fitness-discovery-container">
                <div className="main-sports-fitness-listing-container">
                    <div className="sports-and-drinks-title">
                        <H3 color="#f8a21e" fontWeight={600}>
                            Sports & Fitness Venues in Surat
                        </H3>
                        <Separator />
                    </div>

                    <div className="sports-filter-area-container">
                        <H4 color="#f8a21e" fontWeight={600}>
                            Explore Venues For Your Next Outing
                        </H4>

                        {/* Searchbar */}
                        <div className="sports-and-fitness-searchbar">
                            <Searchbar />
                        </div>

                        {/* Quick Filter Section */}
                        <div className="quick-sports-filter-container">
                            <div className="quick-sports-filter-chips-area">
                                <div className="sports-filter-container">
                                    <FilterBtn
                                        name="Filters"
                                        icon={
                                            <FilterIcon
                                                style={{
                                                    color: '#F8A21E',
                                                    fontSize: '0.875rem'
                                                }}
                                            />
                                        }
                                    />
                                </div>

                                {/* For Future Activation */}
                                {/* <div className="separator-of-filter"></div>

                                <div className="sports-result-active-chips">
                                    <SortBySearchChip />
                                </div> */}
                            </div>
                            {/* For Future Activation */}
                            {/* <div className="quick-sort-by-area">
                                <div className="sports-sort-by-container">
                                    <FilterBtn
                                        name="Sort By"
                                        icon={
                                            <SortByIcon
                                                style={{
                                                    color: '#F8A21E',
                                                    fontSize: '0.875rem'
                                                }}
                                            />
                                        }
                                    />
                                </div>
                            </div> */}
                        </div>

                        {/* Separator */}
                        <Separator />
                    </div>

                    {/* Venue Listing Container */}
                    <div className="sports-fitness-venues-listing-container">
                        <div className="sports-venues-flex-listing-container">
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((_, index) => (
                                <VenueCard key={`venue-${index}`} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
